import type { PaletteMode, Theme } from '@mui/material';
import { Roboto_Mono } from 'next/font/google';
import localFont from 'next/font/local';

import colorSchemes from './colorSchemes';
import customShadows from './customShadows';
import overrides from './overrides';
import shadows from './shadows';
import spacing from './spacing';
import typography from './typography';

const HelveticaNowText = localFont({
  src: [
    {
      path: '../../public/fonts/HelveticaNowText-ExtraLight.woff2',
      weight: '200',
      style: 'normal',
    },
    {
      path: '../../public/fonts/HelveticaNowText-ExtraLight.woff',
      weight: '200',
      style: 'normal',
    },
    {
      path: '../../public/fonts/HelveticaNowText-Light.woff2',
      weight: '300',
      style: 'normal',
    },
    {
      path: '../../public/fonts/HelveticaNowText-Light.woff',
      weight: '300',
      style: 'normal',
    },
    {
      path: '../../public/fonts/HelveticaNowText-Regular.woff2',
      weight: '400',
      style: 'normal',
    },
    {
      path: '../../public/fonts/HelveticaNowText-Regular.woff',
      weight: '400',
      style: 'normal',
    },
    {
      path: '../../public/fonts/HelveticaNowText-Medium.woff2',
      weight: '500',
      style: 'normal',
    },
    {
      path: '../../public/fonts/HelveticaNowText-Medium.woff',
      weight: '500',
      style: 'normal',
    },
    {
      path: '../../public/fonts/HelveticaNowText-Medium.woff2',
      weight: '600',
      style: 'normal',
    },
    {
      path: '../../public/fonts/HelveticaNowText-Medium.woff',
      weight: '600',
      style: 'normal',
    },
  ],
  variable: '--font-helvetica-now-text',
});

const theme = (mode: PaletteMode): Theme => {
  return {
    components: overrides(),
    colorSchemes: colorSchemes(),
    ...spacing,
    shape: {
      borderRadius: 4,
      customBorderRadius: {
        xs: 2,
        sm: 4,
        md: 6,
        lg: 8,
        xl: 10,
      },
    },
    shadows: shadows(mode),
    typography: typography(HelveticaNowText.style.fontFamily),
    customShadows: customShadows(mode),
    mainColorChannels: {
      light: '46 38 61',
      dark: '231 227 252',
      lightShadow: '46 38 61',
      darkShadow: '19 17 32',
    },
  } as Theme;
};

export default theme;

export const robotoMono = Roboto_Mono({
  subsets: ['latin'],
  display: 'swap',
});
